import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { NUR_LESEND_GRUND } from '../../config/ebenen';
import EinstellungenFenster from '../../components/EinstellungenFenster';
import { KONTO_TEXTE } from './kontoTexte';
import { inSichtNurLesend } from './seiten';

// „Meine Einstellungen“ (Profil-Nachbau F-02 Rahmen D1, Benny: „nahh wie bei meingpt machen mit der extra seite“; F-19, F-26 mit
// Nachtrag; BAU-EINSTELLUNGEN.md B1): eine Seite des Fensters „Einstellungen“ (components/EinstellungenFenster.tsx), Abschnitt
// „Mein Konto“. Die Leiste mit allen Abschnitten baut das Fenster; die Bereiche lesen alle Gruppen über useGruppen, deshalb bekommt
// der Outlet sie.
export default function KontoSeite({ unten = false }: { unten?: boolean }) {
  const { user } = useAuth();
  const location = useLocation();
  const pfad = location.pathname.replace(/\/+$/, '');
  // Paket 08 Schritt 6 (F-08-6, VE-23): in einer Sicht liegen die persönlichen Bereiche hinter der Lesegrenze, außer „Darstellung“.
  const aktiveSicht = user?.sicht?.aktiv;
  return <EinstellungenFenster unten={unten} lesegrenze={aktiveSicht && inSichtNurLesend(pfad) ? NUR_LESEND_GRUND(aktiveSicht.linse) : undefined}
    inhaltName={KONTO_TEXTE.inhaltName}>
    {gruppen => <Outlet context={gruppen} />}
  </EinstellungenFenster>;
}
